import { render, staticRenderFns } from "./BankAccountManageDialog.component.vue?vue&type=template&id=61c5ae28"
import script from "./BankAccountManageDialog.component.vue?vue&type=script&lang=js"
export * from "./BankAccountManageDialog.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports